/**
 * @generated SignedSource<<ccb8e76181dfbdffb6f315b163411db4>>
 * @relayHash f69c0d2a377c2f2fc1d16ee34a3d0e5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bff6e2c88dcd56c725951dcb07120f7039de14bb385a53dac07f45c609702bcb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery } from './ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery.graphql';

const node: PreloadableConcreteRequest<ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bff6e2c88dcd56c725951dcb07120f7039de14bb385a53dac07f45c609702bcb",
    "metadata": {},
    "name": "ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
